module.exports = __webpack_public_path__ + "static/img/preview-03.f74ba0b4.webp";